require('angular');
require('./angular-scroll');

module.exports = 'duScroll';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-scroll/index.js
// module id = 506
// module chunks = 6